import Component from '../abstracts/Component';

export default class QuickBuyComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-quick-buy',
    };
  }

  constructor() {
    super();
  }

  bindEvents() {

    this.$on('click.quickBuy', ({event}) => {
      event.preventDefault();

      const $el = event.target.closest(this.SELECTORS.main);
      const href= $el.getAttribute('href');

      this.getPage(href)
        .then(res => {
          $('.modal-quick-buy .vex-close').trigger('click');
          this.$emit(this.$customEvents.MODAL_EVENTS.show, {
            unsafeContent: res,
            modalClass: 'modal-quick-buy vex-medium-width'
          });
      });

    }, 'body', this.SELECTORS.main);
  }

  getPage(url, showLoader = true) {

    const ajaxConf = {
      type: 'GET',
      url: url,
      data: {
        quickBuy: true
      }
    };

    if (showLoader) ajaxConf.beforeSend = () => this.$emit(this.$customEvents.LOADER_EVENTS.show);

    return $.ajax(ajaxConf);
  }

  render() {
    if (document.querySelector(this.SELECTORS.main)) {
      this.bindEvents();
    }
  }
}
